import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { environment } from "src/environments/environment";
import { MediaObserver } from "@angular/flex-layout";
import { WurmService } from "../wurm.service";
import { finalize } from "rxjs/operators";
import * as _ from "lodash";

@Component({
  selector: 'esc-wurm-form',
  templateUrl: './wurm-form.component.html',
  styleUrls: ['./wurm-form.component.scss']
})
export class WurmFormComponent implements OnInit {
  @Input() detail;
  @Input() mode;
  @Output() saving = new EventEmitter();
  @Output() closeForm = new EventEmitter();

  public isDisabled;
  loading = {
    submit: false
  };
  usernameRequired;
  fullnameRequired;
  
  constructor(
    private fb: FormBuilder,
    public helper: HelperService,
    public media: MediaObserver,
    private dialogService: DialogService,
    private wurmMntService: WurmService,
    public languageService: LanguageService,
    ) { }

  public formGroup: FormGroup;

  ngOnInit() {
    this.initForm();
    // console.log(this.detail);
  }

  initForm() {
    this.formGroup = this.fb.group({
      username: [_.get(this.detail, "username"), [Validators.required]],

      fullname: [_.get(this.detail, "fullname"), [Validators.required]],

      status: _.get(this.detail, "is_active") == 1 ? true : false
    });

    this.toggleDisable();
  }

  toggleDisable() {
    if (!_.get(this.detail, 'id')) {
      this.formGroup.get("status").setValue(true);
      this.formGroup.get("status").disable({ emitEvent: false });
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  webUserSelected(ev) {
    this.formGroup.get('username').setValue(ev);
    this.formGroup.get('username').markAsTouched();
  }

  recipientSelected(ev) {
    console.log(ev)
    this.formGroup.get('fullname').setValue(ev);
    this.formGroup.get('fullname').markAsTouched();
  }

  isFormValid() {
    if(this.formGroup.valid) {
      this.saveChanges()
    }
    else {
      for (let ctrl in this.formGroup.controls) {
        if(!this.formGroup.controls[ctrl].valid) {
          this[ctrl+"Required"] = true;
        }
      }
    }
  }

  saveChanges() {
    this.loading.submit = true;
    this.formGroup.disable();

    let is_active = _.get(this.formGroup.get("status"), "value") ? 1 : 0;

    let obj = {
      data: [
        {
          id: _.get(this.detail, "id") || 0,

          user_id: _.get(this.detail, "id") ? _.get(this.detail, 'user_id') : _.get(this.formGroup.get("username"), "value.id"),

          recipient_id: _.get(this.detail, "id") ? [_.get(this.detail, 'recipient_id') || 0] : _.get(this.formGroup.get("fullname"), "value"),

          is_active: is_active
        }
      ]
    };

    this.saving.emit(true);

    this.wurmMntService.insert(obj).pipe(
        finalize(() => {
          this.loading.submit = false;
          this.saving.emit(false);
          this.formGroup.enable();
          this.toggleDisable();
        })
      )
      .subscribe(
        (res: any) => {
          this.loading.submit = false;
          if (environment.showLogs) {
            console.log(res);
          }

          if (_.has(res, 'status') && _.get(res, 'status') == 0) {
            this.helper.networkErrorMessage();
            return;
          }
          
          if(this.helper.displayErrorMessage(res)) return;

          if (_.get(res, 'success.count') > 0) {
            //the ff needs to be an obj to display detail correctly
            obj.data[0]["username"] = _.get(this.formGroup.get("username"), "value.fullname") || _.get(this.formGroup.get("username"), "value");

            obj.data[0]["full_name"] = _.get(this.formGroup.get("username"), "value.fullname") || _.get(this.detail, "full_name");

            obj.data[0]["fullname"] = _.get(this.formGroup.get("fullname"), "value.fullname") || _.get(this.formGroup.get("fullname"), "value");

            obj.data[0]["reference_code"] = _.get(this.formGroup.get("fullname"), "value.reference_code") || _.get(this.detail, "reference_code");

            this.saving.emit(obj.data);
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_DATA_UPDATED", {}));
            this.close(true);
          }
        },
        err => {
          console.log(err);
        }
      );
  }

  disableSaveBtn() {
    return this.loading.submit || (this.formGroup.touched && !this.formGroup.valid)
  }

  confirmChanges() {
    if(this.formGroup.touched && this.formGroup.valid) {
      this.dialogService.openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_SAVE_CHANGES", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if(result) {
          this.saveChanges();
        } else {
          this.close(false);
        }
      })
    }
    else {
      this.close(false);
    }
  }

  close(data) {
    this.closeForm.next(data);
  }
}